import React from 'react';
import { ReactComponent as Background } from 'products/global/assets/img/icons/av-bg.svg';
import { ReactComponent as Head } from 'products/global/assets/img/icons/av-head.svg';
import { ReactComponent as Hair } from 'products/global/assets/img/icons/av-hair.svg';
import { ReactComponent as Brows } from 'products/global/assets/img/icons/av-brows.svg';
import { ReactComponent as Eyes } from 'products/global/assets/img/icons/av-eyes.svg';
import { ReactComponent as Beak } from 'products/global/assets/img/icons/av-beak.svg';
import { ReactComponent as Tops } from 'products/global/assets/img/icons/av-tops.svg';
import { ReactComponent as Eyewear } from 'products/global/assets/img/icons/av-eyewear.svg';
import { ReactComponent as Headwear } from 'products/global/assets/img/icons/av-headwear.svg';
import { ReactComponent as Gadget } from 'products/global/assets/img/icons/av-gadget.svg';

export const TABS = [
  {
    label: 'Background',
    icon: <Background />,
    name: 'background'
  },
  {
    label: 'Head shape',
    icon: <Head />,
    name: 'head_shape'
  },
  {
    label: 'Hairstyle',
    icon: <Hair />,
    name: 'hairstyle'
  },
  {
    label: 'Eyebrows',
    icon: <Brows />,
    name: 'eyebrows'
  },
  {
    label: 'Eyes',
    icon: <Eyes />,
    name: 'eyes'
  },
  {
    label: 'Beak',
    icon: <Beak />,
    name: 'beak'
  },
  {
    label: 'Tops',
    icon: <Tops />,
    name: 'top'
  },
  {
    label: 'Eyewear',
    icon: <Eyewear />,
    name: 'eyewear'
  },
  {
    label: 'Headwear',
    icon: <Headwear />,
    name: 'headwear',
    disabled: true
  },
  {
    label: 'Gadget',
    icon: <Gadget />,
    name: 'gadget',
    disabled: true
  }
];
